import { render, staticRenderFns } from "./panel-item-about.vue?vue&type=template&id=05692812&scoped=true&"
import script from "./panel-item-about.js?vue&type=script&lang=js&"
export * from "./panel-item-about.js?vue&type=script&lang=js&"
import style0 from "./panel-item-about.scss?vue&type=style&index=0&id=05692812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05692812",
  null
  
)

component.options.__file = "panel-item-about.vue"
export default component.exports